/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.server.createInviteCodes'

export { $nsid }

/** Create invite codes. */
const main = l.procedure(
  $nsid,
  l.params(),
  l.jsonPayload({
    codeCount: l.withDefault(l.integer(), 1),
    useCount: l.integer(),
    forAccounts: l.optional(l.array(l.string({ format: 'did' }))),
  }),
  l.jsonPayload({
    codes: l.array(l.ref<AccountCodes>((() => accountCodes) as any)),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Input<B = l.BinaryData> = l.InferMethodInput<typeof main, B>
export type $InputBody<B = l.BinaryData> = l.InferMethodInputBody<
  typeof main,
  B
>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $input = main.input,
  $output = main.output

type AccountCodes = {
  $type?: 'com.atproto.server.createInviteCodes#accountCodes'
  account: string
  codes: string[]
}

export type { AccountCodes }

const accountCodes = l.typedObject<AccountCodes>(
  $nsid,
  'accountCodes',
  l.object({ account: l.string(), codes: l.array(l.string()) }),
)

export { accountCodes }
